<template>
  <sui-modal class="wrapper" v-model="visible" :closable="false">
    <sui-modal-header class="header">
      Import stack
    </sui-modal-header>
    <sui-modal-content ref="content" :scrolling="hasScrolling">
      <sui-form :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <FormStack v-model="entity" mode="importing" />
        <sui-message error v-if="apiErrors">
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <div class="ui buttons">
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors" @click="submit()" v-if="entity" data-goal="IMPORT_STACK_TRY">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Deploying started
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import some from 'lodash/some'
  import {mapGetters} from 'vuex'
  import FormStack from '@/components/forms/Stack'
  import ModalForm from '@/mixins/ModalForm'
  import utils from '@/utils'

  export default {
    name: 'ModalImportStack',
    mixins: [
      ModalForm,
    ],
    components: {
      FormStack,
    },
    data() {
      return {
        entityErrors: {
          url: null,
          project: null,
          services: [],
          hosts: [],
        },
        entity: null
      }
    },
    computed: {
      ...mapGetters(['projects']),
      mode() {
        return 'importing'
      },
      hasScrolling() {
        return Boolean(this.entity && (this.entity.services.length || this.entity.hosts.length))
      },
      project() {
        const name = this.$route.params.project
        const project = this.projects.find(entity => entity.id === name || entity.name === name) || {}
        return project
      },
      hasEntityErrors() {
        const hasHostErrors = this.entityErrors && this.entityErrors.hosts.filter(hostErrors => some(hostErrors)).length
        const hasServiceErrors = this.entityErrors && this.entityErrors.services.filter(serviceErrors => some(serviceErrors)).length
        return Boolean(this.entityErrors && (this.entityErrors.url || this.entityErrors.project || hasHostErrors || hasServiceErrors))
      },
    },
    methods: {
      open(data = {}) {
        this.visible = true
        this.entity = {
          url: data.url || null,
          project: data.project || this.project.id || null,
          services: [],
          hosts: [],
        }
      },
      onSuccess() {
        const project = this.projects.find(entity => entity.id === this.entity.project)
        this.close()
        project.openPage()
        utils.reachGoal('IMPORT_STACK_SUCCESS')
      },
      onFail() {
        const $el = this.$refs.content.$el
        $el.scrollTop = $el.scrollHeight
        utils.reachGoal('IMPORT_STACK_FAIL')
      },
    },
    created() {
      this.$modals.importStack = this
    },
  }

</script>

<style scoped>
  .entity + .entity { margin-top: 2em; }
</style>
